import { Loader } from "@ui-kit/Loader";
import { customToast, dismiss, Toast } from "@ui-kit/Toast";
import { useEffect } from "react";
import { tui } from "../locale";
import { useOnlyReloading, useToolsLoading } from "../store/useWorkspaceToolsStore";
import { UPDATE_FAILED_TOAST } from "./useUpdateFailureToast";

export const useLoadingToast = () => {
	const loading = useToolsLoading();
	const onlyReloading = useOnlyReloading();

	useEffect(() => {
		if (!loading) return;
		if (onlyReloading) dismiss(UPDATE_FAILED_TOAST);
		const toastId = customToast(
			({ id }) => (
				<Toast
					closeAction={false}
					focus="medium"
					icon={<Loader size="sm" />}
					id={id}
					size="sm"
					status="info"
					title={
						<span data-testid="workspace-tools-toast">
							{tui(onlyReloading ? "reload.in-progress" : "loading")}
						</span>
					}
				/>
			),
			{ duration: Number.POSITIVE_INFINITY },
		);
		return () => {
			dismiss(toastId);
		};
	}, [loading, onlyReloading]);
};
